/**
 * The backoffice access token, held IN MEMORY only.
 *
 * A LEAF module (imports nothing from the app) so any page can read the live
 * token without an import cycle through AdminAuthContext.
 *
 * Why it exists: the token used to live in `localStorage.adminToken`, and the
 * admin pages still built their own `Authorization` header from it. Once the
 * session model moved the token in-memory that key became permanently empty,
 * and — unlike the dashboard — the backoffice authenticates by setting
 * `axios.defaults.headers.common.Authorization` rather than with a request
 * interceptor. A per-request header WINS over that default in axios, so every
 * one of those call sites was overriding a valid token with "Bearer null" and
 * getting a 401.
 *
 * LEGACY_TOKEN_KEY is only ever REMOVED, never written.
 */
const LEGACY_TOKEN_KEY = 'adminToken';

let accessToken = null;

export const getAdminAccessToken = () => accessToken;

export const setAdminAccessToken = (token) => {
  accessToken = token || null;
  // Retire the previously readable copy.
  localStorage.removeItem(LEGACY_TOKEN_KEY);
};

export const clearAdminAccessToken = () => {
  accessToken = null;
  localStorage.removeItem(LEGACY_TOKEN_KEY);
};

/** Header helper for `fetch` call sites, which get no axios default header. */
export const adminAuthHeader = () => {
  const token = getAdminAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
